import { Paged } from 'api/common/types/Page';
import Http from 'common/services/Http';
import { FamiliesCatalogSearchCriteria, FamiliesSearchCriteria } from './models/FamiliesSearchCriteria';
import { FamilyDto } from './models/FamilyDto';
import IdVersion from 'api/common/types/IdVersion';
import { SearchableSelectTitleSubTitleOption } from 'common/components/searchableSelectInput/optionsFormats/OptionTitleSubTitle';
import { ParameterSectionBaseModel } from 'common/components/parametersSections/models';
import CustomFile from 'common/models/CustomFile';

class FamiliesService {
    public getList (criteria: FamiliesSearchCriteria) {
        return Http.get<Paged<FamilyDto>>('families', criteria);
    }

    public getById (id: string) {
        return Http.get<FamilyDto>('families/' + id);
    }

    public getFamilyParameters (id: string) {
        return Http.get<ParameterSectionBaseModel[]>('families/family/parameters/' + id);
    }

    public getFamilyIdByParameter (familyParameterId: string) {
        return Http.get<string | null>('families/family-id-by-parameter/' + familyParameterId);
    }

    public catalog () {
        return Http.get<SearchableSelectTitleSubTitleOption[]>('families/catalog');
    }

    public getElementsCatalog (criteria?: FamiliesCatalogSearchCriteria) {
        return Http.get<FamilyDto[]>('families/elements/catalog', criteria || {});
    }

    public create(model: FamilyDto, medias: CustomFile[]): Promise<string> {
        return Http.postWithFile('families', model, medias);
    }

    public update(model: FamilyDto, medias: CustomFile[]) {
        return Http.putWithFile('families', model, medias);
    }

    public delete (id: string, deleteRelations: boolean) {
        return Http.delete('families/' + id + '/' + deleteRelations);
    }

    public import (model: ImportFamiliesRequest) {
        return Http.post<ImportFamiliesResult>('families/import', model);
    }

    public recalculateAllAverages () {
        return Http.post<{ count: number }>('families/recalculate-averages', {});
    }
}

export interface ImportFamiliesRequest {
    templateFamilyId: string;
    templateSubFamilyId?: string;
    content: string;
}

export interface ImportFamiliesResult {
    totalCreated: number;
    familiesCreated: number;
    subFamiliesCreated: number;
    errors: string[];
    createdFamilies: ImportedFamilyInfo[];
}

export interface ImportedFamilyInfo {
    id: string;
    name: string;
    isSubFamily: boolean;
}

export default new FamiliesService();
